(function () {
  function swapDeferred(img) {
    var deferredSizes = img.getAttribute('data-sizes');
    var deferredSrcset = img.getAttribute('data-srcset');
    if (deferredSizes) img.setAttribute('sizes', deferredSizes);
    if (deferredSrcset) img.setAttribute('srcset', deferredSrcset);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-sizes');
  }

  if (!('IntersectionObserver' in window)) {
    var swapAll = function () {
      var imgs = document.querySelectorAll('img[data-src]');
      for (var i = 0; i < imgs.length; i++) swapDeferred(imgs[i]);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', swapAll);
    } else {
      swapAll();
    }
    return;
  }

  document.documentElement.classList.add('blur-up-init');

  var SELECTOR = 'img.blur-up:not(.blur-up--armed)';

  function isResizable(src) {
    return /cdn\.shopify\.com|\/cdn\/shop\//.test(src);
  }

  function placeholderUrl(src) {
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', '32');
      u.searchParams.delete('height');
      return u.href;
    } catch (e) {
      return null;
    }
  }

  function reveal(img) {
    img.style.backgroundImage = '';
    img.classList.add('blur-up--loaded');
  }

  function arm(img) {
    img.classList.add('blur-up--armed');

    var deferredSrc = img.getAttribute('data-src');

    if (!deferredSrc && img.complete && img.naturalWidth > 0) {
      reveal(img);
      return;
    }

    var src = deferredSrc || img.getAttribute('src') || img.currentSrc;
    if (src && isResizable(src)) {
      var style = window.getComputedStyle(img);
      img.style.backgroundSize = style.objectFit === 'contain' ? 'contain' : 'cover';
      img.style.backgroundPosition = style.objectPosition;
      var lqip = placeholderUrl(src);
      if (lqip) img.style.backgroundImage = "url('" + lqip + "')";
    }

    img.addEventListener('load', function () { reveal(img); }, { once: true });
    img.addEventListener('error', function () { reveal(img); }, { once: true });

    if (deferredSrc) swapDeferred(img);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          arm(entry.target);
        }
      });
    },
    { rootMargin: '300px 300px' }
  );

  function skip(img) {
    return img.loading === 'eager' || img.getAttribute('fetchpriority') === 'high';
  }

  function register(img) {
    if (skip(img)) {
      img.classList.add('blur-up--armed', 'blur-up--loaded');
    } else {
      io.observe(img);
    }
  }

  function scan(root) {
    var imgs = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) register(imgs[i]);
  }

  function start() {
    scan(document);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SELECTOR)) register(node);
          if (node.querySelectorAll) scan(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
